export default __webpack_public_path__ + "static/media/data-icon.4bc76b32.svg";